import HttpClient from '@naturehouse/nh-essentials/lib/requests/HttpClient';
import LoginManager from '../../app/LoginManager';

class FavoritesStore {
    private readonly _state: FavoritesState = {
        houseIds: []
    };

    get state(): FavoritesState {
        return this._state;
    }

    public async getFavorites(): Promise<void> {
        const loginManager = LoginManager.getInstance();

        if (loginManager.isLoggedIn === false) {
            return;
        }

        const response = await HttpClient.get('/favorites/all');
        const favorites = response as unknown as number[];
        this._state.houseIds = favorites;
    }
}

export { FavoritesStore };
export default new FavoritesStore();
